const avatars = [
    {
        key: 1,
        url: 'https://res.cloudinary.com/ddofzlgdu/image/upload/v1647075947/avatar1_pv7qig.png'
    },
    {
        key: 2,
        url: 'https://res.cloudinary.com/ddofzlgdu/image/upload/v1647075946/avatar2_iny7e5.png'
    },
    {
        key: 3,
        url: 'https://res.cloudinary.com/ddofzlgdu/image/upload/v1647075946/avatar3_r1klpt.png'
    },
    {
        key: 4,
        url: 'https://res.cloudinary.com/ddofzlgdu/image/upload/v1647075946/avatar4_g0ck25.png'
    },
    {
        key: 5,
        url: 'https://res.cloudinary.com/ddofzlgdu/image/upload/v1647078220/avatar5_moja9v.png'
    },
    {
        key: 6,
        url: 'https://res.cloudinary.com/ddofzlgdu/image/upload/v1647078220/avatar6_bvrdgh.png'
    },
    {
        key: 7,
        url: 'https://res.cloudinary.com/ddofzlgdu/image/upload/v1647078220/avatar7_wv6ivw.png'
    },
    {
        key: 8,
        url: 'https://res.cloudinary.com/ddofzlgdu/image/upload/v1647078221/avatar8_pi6l3e.png'
    }
];

export { avatars };